/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */


import { Component, ViewEncapsulation, AfterViewInit, OnDestroy, OnInit, AfterViewChecked, HostListener } from '@angular/core';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { CheckedUncheckedPipe } from '../../shared/pipes/checkedUnchecked.pipe';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
import { Subscription } from 'rxjs';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { RequestsFilterInfo } from '../model/requestsfilterinfo';
import { RequestslistService } from '../services/requestslist.service';
import { StatusTypeResultEntity } from '../../shared/model/requeststatustyperesponse';
declare var $: any;

@Component({
  selector: 'zsd-requestsfilter',
  templateUrl: '../view/requestsfilter.component.html',
  providers : [ CheckedUncheckedPipe ],
  encapsulation: ViewEncapsulation.None
})
export class RequestsFilterComponent implements AfterViewInit, OnDestroy, OnInit, AfterViewChecked {

  static searchString = null;
  static selectedCategories = null;
  static selectedItemTypes = null;
  static selectedStatusTypes = null;
  static categoryIds = null;
  static selectedMyAwaitingApproval = null;
  static selectedMyAwaitingInputs = null;
  static selectedOpenOnly = null;
  categoryResults = new Array<ItemCategoriesResultEntity>();
  itemTypesResults = new Array<ItemTypesResultEntity>();
  statusTypeResults = new  Array<StatusTypeResultEntity>();
  searchCategory:  string;
  searchItemType: string;
  searchStatusType: string;
  requestsFilterInfo: RequestsFilterInfo = new RequestsFilterInfo();
  searchSubscription: Subscription;
  windowSize;
  isFilterOpen: boolean;

  categoryChecked = false;
  itemTypeChecked = false;
  statusTypeChecked = false;
  myApprovalChecked = false;
  myNeedInfoChecked = false;
  openOnlyChecked = false;

 constructor(private requestListService: RequestslistService, private checkedUncheckedPipe: CheckedUncheckedPipe,
  private router: Router, private route: ActivatedRoute, private location: PlatformLocation) {
   this.windowSize = window.innerWidth;
   this.initializeParameters();
   // AOT Changes - Vaibhav
   this.location.onPopState(() => {
     this.ngOnInit();
   });

   // AOT Changes - Vaibhav
   this.location.onHashChange(() => {
     this.ngOnInit();
   });

 }

 initializeParameters() {
  RequestsFilterComponent.selectedCategories = null;
  RequestsFilterComponent.selectedItemTypes = null;
  RequestsFilterComponent.searchString = null;
  RequestsFilterComponent.selectedStatusTypes = null;
  RequestsFilterComponent.selectedMyAwaitingApproval = null;
  RequestsFilterComponent.selectedMyAwaitingInputs = null;
  RequestsFilterComponent.selectedOpenOnly = null;
  this.requestsFilterInfo.searchTerm = null;
}

ngAfterViewChecked() {
  this.windowSize = window.innerWidth;
}

closeFilter() {
  this.isFilterOpen = false;
  $('#requests_filterpanel_control').width('0');
  $('body').css('overflow-y', 'auto');
}

 ngOnInit() {
  this.initFilter();
}

@HostListener('window:resize', ['$event'])
  onResize() {
    // a hack to fix filter display issue when protrait and landscape mode has mobile and desktop layout respectively.
  }

initFilter() {
  let categoryIds = new Array<number>();
  let itemTypeIds = new Array<number>();
  let statusTypeIds = new Array<number>();
  this.route.queryParams.subscribe(params => {
     if (params['searchTerm']) {
       this.requestsFilterInfo.searchTerm = JSON.parse(params['searchTerm']);
     }
    if (params['categoryIds']) {
      categoryIds = JSON.parse(params['categoryIds']);
      if (categoryIds.length > 0) {
        this.categoryChecked = true;
      }
    }
    if (params['itemTypeIds']) {
      itemTypeIds = JSON.parse(params['itemTypeIds']);
      if (itemTypeIds.length > 0) {
        this.itemTypeChecked = true;
      }
    }
    if (params['statusTypeIds']) {
      statusTypeIds = JSON.parse(params['statusTypeIds']);
      if (statusTypeIds.length > 0) {
         this.statusTypeChecked = true;
       }
     }

     if (params['awaitingMyApproval']) {
      this.requestsFilterInfo.awaitingMyApproval = JSON.parse(params['awaitingMyApproval']);
    }

    if (params['awaitingMyInputs']) {
      this.requestsFilterInfo.awaitingMyInputs = JSON.parse(params['awaitingMyInputs']);
    }

    if (params['openRequestsOnly']) {
      this.requestsFilterInfo.openRequestsOnly = JSON.parse(params['openRequestsOnly']);
    }
  });

  if (this.requestsFilterInfo.searchTerm !== null) {
    RequestsFilterComponent.searchString = this.requestsFilterInfo.searchTerm.toString();
  }

  if (this.requestsFilterInfo.awaitingMyApproval !== null && this.requestsFilterInfo.awaitingMyApproval === true) {
    this.myApprovalChecked = true;
  }

  if (this.requestsFilterInfo.awaitingMyInputs !== null && this.requestsFilterInfo.awaitingMyInputs === true) {
    this.myNeedInfoChecked = true;
  }

  if (this.requestsFilterInfo.openRequestsOnly !== null && this.requestsFilterInfo.openRequestsOnly === true) {
    this.openOnlyChecked = true;
  }

  this.getCategories(categoryIds);
  this.getItemtypes(itemTypeIds);
  this.getStatusTypes(statusTypeIds);
}

getCategories(categoryIds: Array<number>) {
  this.requestListService.getItemCategories().subscribe(
    (categoryResponse: ItemCategoriesResultEntity[]) => {
          this.categoryResults = categoryResponse;
          for (let categoryId of categoryIds) {
            for (let j = 0; j < this.categoryResults.length; j++) {
              if (this.categoryResults[j].categoryId === categoryId) {
                this.categoryResults[j].checked = true;
              }
            }
          }
          this.categoryResults = this.checkedUncheckedPipe.transform(this.categoryResults, 'categoryName');
    }
  );
}


getItemtypes(itemTypeIds: Array<number>) {
  this.requestListService.getItemTypes().subscribe(
    (itemTypesResponses: ItemTypesResultEntity[]) => {
      this.itemTypesResults = itemTypesResponses;

      for (let itemTypeId of itemTypeIds) {
        for (let j = 0; j < this.itemTypesResults.length; j++) {
          if (this.itemTypesResults[j].itemTypeId === itemTypeId) {
            this.itemTypesResults[j].checked = true;
          }
        }
      }
      this.itemTypesResults = this.checkedUncheckedPipe.transform(this.itemTypesResults, 'itemTypeName');
    });
}

  getStatusTypes(statusTypeIds: Array<number>) {
    this.requestListService.getStatusTypes().subscribe(
      (statusTypeResponse: StatusTypeResultEntity[]) => {
        this.statusTypeResults = statusTypeResponse;
        for (let statusTypeId of statusTypeIds) {
          for (let j = 0; j < this.statusTypeResults.length; j++) {
            for (let statusId of Array.from(this.statusTypeResults[j].statusId.values())) {
              if (statusId === statusTypeId) {
                this.statusTypeResults[j].checked = true;
              }
            }
          }
        }
        this.statusTypeResults = this.checkedUncheckedPipe.transform(this.statusTypeResults, 'statusName');
      }
    );
  }
applyFilter() {
  this.categoryResults = this.categoryResults.filter(category => category.checked === true);
  this.itemTypesResults = this.itemTypesResults.filter(itemType => itemType.checked === true);
  this.statusTypeResults = this.statusTypeResults.filter(statusType => statusType.checked === true);

  let categoryIds = new Array<number>();
  for (let itemCategory of this.categoryResults) {
    categoryIds.push(itemCategory.categoryId);
  }

  let itemTypeIds = new Array<number>();
  for (let itemType of this.itemTypesResults) {
    itemTypeIds.push(itemType.itemTypeId);
  }

  let statusTypeIds = new Array<number>();
  for (let statusType of this.statusTypeResults) {
    for ( let item of Array.from(statusType.statusId.values())) {
      statusTypeIds.push(item);
    }
  }

  if (RequestsFilterComponent.searchString !== null) {
    RequestsFilterComponent.searchString = JSON.stringify(RequestsFilterComponent.searchString);
  }
  if (categoryIds.length > 0) {
    RequestsFilterComponent.selectedCategories = JSON.stringify(categoryIds);
    this.requestsFilterInfo.categoryIds = categoryIds;
  }
  if (itemTypeIds.length > 0) {
    RequestsFilterComponent.selectedItemTypes = JSON.stringify(itemTypeIds);
    this.requestsFilterInfo.itemTypeIds = itemTypeIds;
  }
  if (statusTypeIds.length > 0) {
    RequestsFilterComponent.selectedStatusTypes = JSON.stringify(statusTypeIds);
    this.requestsFilterInfo.statusTypeIds = statusTypeIds;
  }
  if ( this.myApprovalChecked  !== null && this.myApprovalChecked === true) {
    RequestsFilterComponent.selectedMyAwaitingApproval = JSON.stringify(true);
  }
  if (this.myNeedInfoChecked !== null && this.myNeedInfoChecked === true) {
    RequestsFilterComponent.selectedMyAwaitingInputs = JSON.stringify(true);
  }
  if (this.openOnlyChecked !== null && this.openOnlyChecked === true) {
    RequestsFilterComponent.selectedOpenOnly = JSON.stringify(true);
  }

  let navigationExtras: NavigationExtras = {
    queryParams: {
      'searchTerm': RequestsFilterComponent.searchString,
      'categoryIds': RequestsFilterComponent.selectedCategories,
      'itemTypeIds': RequestsFilterComponent.selectedItemTypes,
      'statusTypeIds' : RequestsFilterComponent.selectedStatusTypes,
      'awaitingMyApproval' : RequestsFilterComponent.selectedMyAwaitingApproval,
      'awaitingMyInputs' : RequestsFilterComponent.selectedMyAwaitingInputs,
      'openRequestsOnly' : RequestsFilterComponent.selectedOpenOnly
    },
    queryParamsHandling: 'merge'
  };

  this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
    this.router.navigate([CommonConstants.REQUEST_COMPONENT], navigationExtras ));

  this.closeFilter();
}

 // will be called on click of clear button
 clearFilter() {
  this.resetFilter();
  if (RequestsFilterComponent.searchString !== null) {
    RequestsFilterComponent.searchString = JSON.stringify(RequestsFilterComponent.searchString);
  }
  let navigationExtras: NavigationExtras = {
    queryParams: {
      'searchTerm': RequestsFilterComponent.searchString,
    },
    queryParamsHandling: 'merge'
  };
  this.router.navigateByUrl('/my-profile', { skipLocationChange: true }).then(() =>
    this.router.navigate([CommonConstants.REQUEST_COMPONENT], navigationExtras ));

  this.closeFilter();
}

// will reset the selected filter values
resetFilter() {
  RequestsFilterComponent.selectedCategories = null;
  RequestsFilterComponent.selectedItemTypes = null;
  RequestsFilterComponent.selectedStatusTypes = null;
  RequestsFilterComponent.selectedMyAwaitingInputs = null;
  RequestsFilterComponent.selectedMyAwaitingApproval = null;
  RequestsFilterComponent.selectedOpenOnly = null;
  this.searchCategory = '';
  this.searchItemType = '';
  this.searchStatusType = '';
  this.categoryResults.forEach(category => category.checked = false);
  this.itemTypesResults.forEach(itemType => itemType.checked = false);
  this.statusTypeResults.forEach(statusType => statusType.checked = false);
}

ngAfterViewInit() {
  $(document).ready(function () {
    $('[data-toggle=popover]').popover();
  });
}


ngOnDestroy() {
}



}
